import { useCallback, useEffect } from 'react';
import { nanoid } from 'nanoid';
import { assertIsDashboardPluginProps, LayoutUtils, useListener } from '@deephaven/dashboard';
import { MarkdownPanel } from "./panels/index.js";
import MarkdownUtils from "./controls/markdown/MarkdownUtils.js";
import MarkdownEvent from "./events/MarkdownEvent.js";
export function MarkdownPlugin(props) {
  assertIsDashboardPluginProps(props);
  var id = props.id,
    layout = props.layout,
    panelManager = props.panelManager,
    registerComponent = props.registerComponent;
  var handleOpen = useCallback(function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$metadata = _ref.metadata,
      metadata = _ref$metadata === void 0 ? {} : _ref$metadata,
      _ref$id = _ref.id,
      panelId = _ref$id === void 0 ? nanoid() : _ref$id,
      _ref$focusElement = _ref.focusElement,
      focusElement = _ref$focusElement === void 0 ? LayoutUtils.DEFAULT_FOCUS_SELECTOR : _ref$focusElement,
      _ref$createNewStack = _ref.createNewStack,
      createNewStack = _ref$createNewStack === void 0 ? false : _ref$createNewStack,
      _ref$dragEvent = _ref.dragEvent,
      dragEvent = _ref$dragEvent === void 0 ? undefined : _ref$dragEvent;
    var openedMarkdowns = panelManager.getOpenedPanelConfigsOfType(MarkdownPanel.COMPONENT);
    var usedTitles = openedMarkdowns.map(markdown => {
      var _markdown$title;
      return (_markdown$title = markdown.title) !== null && _markdown$title !== void 0 ? _markdown$title : '';
    });
    var panelTitle = title != null && title !== '' ? title : MarkdownUtils.getNewMarkdownTitle(usedTitles);
    var content = null;
    var config = {
      type: 'react-component',
      component: MarkdownPanel.COMPONENT,
      props: {
        id: panelId,
        metadata,
        panelState: {
          content
        },
        localDashboardId: id
      },
      title: panelTitle,
      id: panelId
    };
    var root = layout.root;
    LayoutUtils.openComponent({
      root,
      config,
      focusElement,
      createNewStack,
      dragEvent
    });
  }, [id, layout, panelManager]);
  useEffect(function registerComponentsAndReturnCleanup() {
    var cleanups = [registerComponent(MarkdownPanel.COMPONENT, MarkdownPanel)];
    return () => {
      cleanups.forEach(cleanup => cleanup());
    };
  }, [registerComponent]);
  useListener(layout.eventHub, MarkdownEvent.OPEN, handleOpen);
  return null;
}
export default MarkdownPlugin;
//# sourceMappingURL=MarkdownPlugin.js.map